// extracted by mini-css-extract-plugin
module.exports = {"container":"_1apZA","title":"_3wwaw","text":"_2AKDF","button":"_2wVZB"};